/* Miolora quick order form. COD → /apps/order (app proxy → Cloudflare Worker); other methods → Shopify checkout. */
(() => {
  const root = document.querySelector("[data-mio-order]");
  if (!root || root.dataset.ready) return;
  root.dataset.ready = "1";

  const $ = (s, el = root) => el.querySelector(s);
  const $$ = (s, el = root) => [...el.querySelectorAll(s)];
  // Liquid's `t` filter HTML-escapes; decode once so messages render as plain text.
  const decode = (s) => { const d = document.createElement("textarea"); d.innerHTML = s; return d.value; };
  const T = Object.fromEntries(Object.entries(JSON.parse($("[data-mio-i18n]").textContent)).map(([k, v]) => [k, decode(v)]));
  const ENDPOINT = root.dataset.endpoint;
  const LOCALE = root.dataset.locale;
  const MONEY_FORMAT = root.dataset.moneyFormat || "{{amount}} EGP";
  const form = $("[data-mio-form]");
  const submitBtn = $("[data-mio-submit]");
  const alertBox = $("[data-mio-alert]");

  let cart = JSON.parse($("[data-mio-cart]").textContent);
  let quote = null;
  let appliedCode = "";
  let startedAt = 0;
  let idem = uuid();
  let busy = false;
  let quoteCtl = null;
  let tracked = { begin: false, ship: false };

  // ---------- helpers ----------
  function uuid() {
    if (crypto.randomUUID) return crypto.randomUUID();
    const b = crypto.getRandomValues(new Uint8Array(16));
    b[6] = (b[6] & 15) | 64; b[8] = (b[8] & 63) | 128;
    const h = [...b].map((x) => x.toString(16).padStart(2, "0")).join("");
    return `${h.slice(0, 8)}-${h.slice(8, 12)}-${h.slice(12, 16)}-${h.slice(16, 20)}-${h.slice(20)}`;
  }

  function money(amount) {
    const n = Number(amount) || 0;
    const fmt = (d, ts = ",", ds = ".") => {
      const [i, f] = n.toFixed(d).split(".");
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, ts) + (f ? ds + f : "");
    };
    return MONEY_FORMAT.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => ({
      amount: fmt(2), amount_no_decimals: fmt(0), amount_with_comma_separator: fmt(2, ".", ","),
      amount_no_decimals_with_comma_separator: fmt(0, "."),
    })[k] ?? fmt(2));
  }

  const latin = (s) => String(s || "").replace(/[٠-٩]/g, (d) => "٠١٢٣٤٥٦٧٨٩".indexOf(d)).replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d));

  function normPhone(raw) {
    let p = latin(raw).replace(/[\s\-().]/g, "");
    if (p.startsWith("+20")) p = "0" + p.slice(3);
    else if (p.startsWith("0020")) p = "0" + p.slice(4);
    else if (/^20(1[0125]\d{8})$/.test(p)) p = "0" + p.slice(2);
    else if (/^1[0125]\d{8}$/.test(p)) p = "0" + p;
    return /^01[0125]\d{8}$/.test(p) ? p : null;
  }

  const val = (name) => (form.elements[name]?.value || "").replace(/\s+/g, " ").trim();
  const lines = () => cart.items.map((i) => ({ variant_id: i.variant_id, quantity: i.quantity }));
  const payMode = () => form.elements.pay?.value || "cod";

  // ---------- validation ----------
  const RULES = {
    phone: () => (normPhone(val("phone")) ? "" : T.err_phone),
    name: () => (val("name").length >= 2 ? "" : T.err_name),
    governorate: () => (val("governorate") ? "" : T.err_governorate),
    city: () => (val("city").length >= 2 ? "" : T.err_city),
    address: () => (val("address").length >= 5 ? "" : T.err_address),
    note: () => (val("note").length <= 300 ? "" : T.err_note),
  };
  const SERVER_ERR = {
    phone_invalid: "err_phone", name_invalid: "err_name", governorate_invalid: "err_governorate",
    city_invalid: "err_city", address_invalid: "err_address", note_invalid: "err_note", discount_invalid: "code_bad",
  };

  function showError(name, msg) {
    const input = form.elements[name];
    const out = $(`[data-err-for="${name}"]`);
    if (!input || !out) return;
    out.textContent = msg || "";
    input.setAttribute("aria-invalid", msg ? "true" : "false");
    input.closest(".mio-field")?.classList.toggle("is-invalid", !!msg);
  }

  function check(name) {
    const msg = RULES[name]();
    showError(name, msg);
    return !msg;
  }

  function checkAll() {
    let first = null;
    for (const name of Object.keys(RULES)) if (!check(name) && !first) first = form.elements[name];
    return first;
  }

  // Validate on leaving a field; once a field showed an error, re-check while typing.
  for (const name of Object.keys(RULES)) {
    const el = form.elements[name];
    el.addEventListener("blur", () => { if (val(name) || el.getAttribute("aria-invalid") === "true") check(name); });
    el.addEventListener("input", () => { if (el.getAttribute("aria-invalid") === "true") check(name); });
  }
  form.elements.phone.addEventListener("blur", () => {
    const p = normPhone(val("phone"));
    if (p) form.elements.phone.value = p;
  });

  form.addEventListener("focusin", () => {
    if (!startedAt) startedAt = Date.now();
    if (!tracked.begin) { tracked.begin = true; track("begin_checkout"); }
  });

  // ---------- quote / summary ----------
  function renderSummary() {
    const sub = quote ? quote.subtotal + (quote.discount || 0) : cart.items_subtotal_price / 100;
    $("[data-mio-subtotal]").textContent = money(quote ? quote.subtotal : cart.items_subtotal_price / 100);
    const discRow = $("[data-mio-disc-row]");
    if (quote && quote.discount > 0) {
      discRow.hidden = false;
      $("[data-mio-discount]").textContent = "− " + money(quote.discount);
    } else discRow.hidden = true;
    const ship = $("[data-mio-shipping]");
    if (quote && quote.shipping_known) ship.textContent = quote.shipping > 0 ? money(quote.shipping) : "0";
    else if (!val("governorate")) ship.textContent = T.ship_pick;
    const total = quote ? quote.total : cart.total_price / 100;
    $("[data-mio-total]").textContent = money(total);
    updateButton();
    return sub;
  }

  function updateButton() {
    if (busy) return;
    const mode = payMode();
    const total = quote && quote.shipping_known ? money(quote.total) : "";
    submitBtn.textContent =
      mode === "cod" ? T.submit_cod.replace("{total}", total).replace(/\s·\s*$/, "")
      : mode === "installments" ? T.submit_inst : T.submit_online;
  }

  async function refreshQuote(code = appliedCode) {
    if (!cart.items.length) return null;
    quoteCtl?.abort();
    quoteCtl = new AbortController();
    root.classList.add("is-quoting");
    try {
      const r = await fetch(`${ENDPOINT}/quote`, {
        method: "POST",
        headers: { "content-type": "application/json", accept: "application/json" },
        body: JSON.stringify({ lines: lines(), governorate: val("governorate"), discount: code }),
        signal: quoteCtl.signal,
      });
      const data = await r.json();
      if (data.ok) { quote = data; renderSummary(); }
      else if (data.error === "not_served") showError("governorate", T.err_not_served);
      return data;
    } catch (e) {
      if (e.name !== "AbortError") console.warn("[mio] quote failed", e);
      return null;
    } finally {
      root.classList.remove("is-quoting");
    }
  }

  form.elements.governorate.addEventListener("change", () => {
    check("governorate");
    refreshQuote();
    if (!tracked.ship && val("governorate")) { tracked.ship = true; track("add_shipping_info"); }
  });
  form.addEventListener("change", (e) => { if (e.target.name === "pay") updateButton(); });

  // ---------- discount code ----------
  const codeInput = form.elements.discount;
  const applyBtn = $("[data-mio-apply]");
  const codeMsg = $("[data-mio-code-msg]");

  async function applyCode() {
    const code = codeInput.value.trim();
    if (appliedCode && code === appliedCode) { // acts as "Remove"
      appliedCode = ""; codeInput.value = ""; codeInput.readOnly = false;
      applyBtn.textContent = T.apply; codeMsg.textContent = ""; codeMsg.className = "mio-code__msg";
      return refreshQuote("");
    }
    if (!code) return codeInput.focus();
    applyBtn.disabled = true;
    const data = await refreshQuote(code);
    applyBtn.disabled = false;
    if (data?.ok && data.discount_applied) {
      appliedCode = code; codeInput.readOnly = true; applyBtn.textContent = T.remove;
      codeMsg.textContent = T.code_ok; codeMsg.className = "mio-code__msg is-ok";
    } else {
      codeMsg.textContent = T.code_bad; codeMsg.className = "mio-code__msg is-bad";
      if (data?.ok) refreshQuote("");
    }
  }
  applyBtn.addEventListener("click", applyCode);
  codeInput.addEventListener("keydown", (e) => { if (e.key === "Enter") { e.preventDefault(); applyCode(); } });

  // ---------- cart sync (theme updates quantities via AJAX) ----------
  let syncTimer;
  async function syncCart() {
    try {
      const fresh = await (await fetch("/cart.js", { headers: { accept: "application/json" } })).json();
      const sig = (c) => c.items.map((i) => `${i.variant_id}x${i.quantity}`).join(",");
      const changed = sig(fresh) !== sig(cart);
      cart = fresh;
      root.classList.toggle("mio-hidden", cart.item_count === 0);
      if (changed) { idem = uuid(); quote = null; renderSummary(); if (cart.items.length) refreshQuote(); }
    } catch (e) { console.warn("[mio] cart sync failed", e); }
  }
  const scheduleSync = () => { clearTimeout(syncTimer); syncTimer = setTimeout(syncCart, 400); };
  const items = document.querySelector("[data-cart-items]");
  if (items) new MutationObserver(scheduleSync).observe(items, { childList: true, subtree: true });
  ["cart:refresh", "cart:updated", "cart:change", "theme4:cart:update"].forEach((ev) => document.addEventListener(ev, scheduleSync));

  // ---------- analytics ----------
  function analyticsItems() {
    return cart.items.map((i) => ({
      item_id: String(i.sku || i.variant_id), item_name: i.product_title, item_variant: i.variant_title || undefined,
      price: i.final_price / 100, quantity: i.quantity,
    }));
  }
  function track(event, extra = {}) {
    const value = quote ? quote.total : cart.total_price / 100;
    try {
      window.gtag?.("event", event, { currency: "EGP", value, items: analyticsItems(), ...extra });
      if (window.fbq) {
        if (event === "begin_checkout") window.fbq("track", "InitiateCheckout", { currency: "EGP", value, num_items: cart.item_count });
        if (event === "purchase") window.fbq("track", "Purchase", { currency: "EGP", value: extra.value, content_type: "product",
          content_ids: cart.items.map((i) => String(i.variant_id)) }, { eventID: extra.transaction_id });
      }
    } catch (e) { console.warn("[mio] analytics", e); }
  }

  // ---------- submit ----------
  function attributes() {
    const q = new URLSearchParams(location.search);
    const stored = (() => { try { return JSON.parse(sessionStorage.getItem("mio_attr") || "{}"); } catch { return {}; } })();
    const cookie = (n) => document.cookie.split("; ").find((c) => c.startsWith(n + "="))?.split("=")[1];
    return {
      ...stored,
      ...Object.fromEntries(["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "utm_id", "fbclid", "gclid", "ttclid"]
        .filter((k) => q.get(k)).map((k) => [k, q.get(k)])),
      fbp: cookie("_fbp"), fbc: cookie("_fbc"), locale: LOCALE,
    };
  }

  function setBusy(on) {
    busy = on;
    submitBtn.disabled = on;
    submitBtn.setAttribute("aria-busy", on ? "true" : "false");
    if (on) submitBtn.textContent = T.sending; else updateButton();
  }

  function showAlert(msg, waLink) {
    alertBox.hidden = !msg;
    alertBox.textContent = msg || "";
    if (waLink) {
      const a = document.createElement("a");
      a.href = waLink; a.target = "_blank"; a.rel = "noopener"; a.className = "mio-btn mio-btn--wa"; a.textContent = T.wa;
      alertBox.append(" ", a);
    }
  }

  function waFallback() {
    const n = root.dataset.whatsapp;
    const items = cart.items.map((i) => `• ${i.quantity} × ${i.product_title}${i.variant_title ? " (" + i.variant_title + ")" : ""}`).join("\n");
    const text = `${T.title}\n${items}\n${val("name")} · ${normPhone(val("phone")) || val("phone")}\n${val("city")}, ${val("address")}`;
    return `https://wa.me/${n}?text=${encodeURIComponent(text)}`;
  }

  async function goToCheckout() {
    // Keep the details on the cart, then pre-fill Shopify checkout with them.
    const phone = normPhone(val("phone"));
    const [first, ...rest] = val("name").split(" ");
    await fetch("/cart/update.js", {
      method: "POST", headers: { "content-type": "application/json" },
      body: JSON.stringify({ attributes: { _mio_payment: payMode() }, note: val("note") }),
    }).catch(() => {});
    const p = new URLSearchParams({
      "checkout[shipping_address][first_name]": first || "",
      "checkout[shipping_address][last_name]": rest.join(" ") || first || "",
      "checkout[shipping_address][address1]": val("address"),
      "checkout[shipping_address][city]": val("city"),
      "checkout[shipping_address][province]": val("governorate"),
      "checkout[shipping_address][country]": "EG",
      "checkout[shipping_address][phone]": phone ? "+2" + phone : "",
      locale: LOCALE,
    });
    if (appliedCode) p.set("discount", appliedCode);
    location.href = "/checkout?" + p.toString();
  }

  form.addEventListener("submit", async (e) => {
    e.preventDefault();
    if (busy) return;
    showAlert("");
    const firstBad = checkAll();
    if (firstBad) { showAlert(T.err_summary); firstBad.focus(); return; }
    if (!cart.items.length) { showAlert(T.err_cart); return; }

    if (payMode() !== "cod") { setBusy(true); return goToCheckout(); }

    setBusy(true);
    let data = null;
    try {
      const r = await fetch(`${ENDPOINT}/submit`, {
        method: "POST",
        headers: { "content-type": "application/json", accept: "application/json" },
        body: JSON.stringify({
          idem, lines: lines(), phone: val("phone"), name: val("name"), governorate: val("governorate"),
          city: val("city"), address: val("address"), note: val("note"), discount: appliedCode,
          website: form.elements.website.value, fill_ms: startedAt ? Date.now() - startedAt : 0,
          locale: LOCALE, attributes: attributes(),
        }),
      });
      data = await r.json().catch(() => null);
    } catch (err) { console.warn("[mio] submit failed", err); }
    setBusy(false);

    if (data?.ok) return success(data);
    if (data?.error === "invalid" && data.fields) {
      let first = null;
      for (const [f, code] of Object.entries(data.fields)) {
        const msg = T[SERVER_ERR[code]] || T.err_summary;
        if (f === "discount") { codeMsg.textContent = msg; codeMsg.className = "mio-code__msg is-bad"; first ||= codeInput; continue; }
        showError(f, msg); first ||= form.elements[f];
      }
      showAlert(T.err_summary); first?.focus(); return;
    }
    if (data?.error === "not_served") { showError("governorate", T.err_not_served); form.elements.governorate.focus(); return; }
    if (data?.error === "rate_limited" || data?.error === "in_progress") { showAlert(T.err_wait); return; }
    if (data?.error === "cart_invalid") { showAlert(T.err_cart); return; }
    showAlert(T.err_server, data?.whatsapp || waFallback());
  });

  function success(data) {
    const { order } = data;
    track("purchase", { transaction_id: order.name, value: order.total, shipping: data.shipping, coupon: appliedCode || undefined });
    $("[data-mio-ok-num]").textContent = order.name || "✓";
    $("[data-mio-ok-total]").textContent = money(order.total);
    $("[data-mio-ok-call]").textContent = T.ok_call.replace("{phone}", normPhone(val("phone")) || "");
    form.hidden = true;
    const ok = $("[data-mio-success]");
    ok.hidden = false;
    document.querySelectorAll("[data-cart-wrapper], [data-cart-content]").forEach((el) => (el.hidden = true));
    ok.scrollIntoView({ behavior: "smooth", block: "start" });
    ok.focus({ preventScroll: true });
    fetch("/cart/clear.js", { method: "POST" }).then(() => {
      document.querySelectorAll("[data-cart-count]").forEach((el) => (el.textContent = "0"));
    }).catch(() => {});
  }

  renderSummary();
  if (location.hash === "#mio-order") setTimeout(() => form.elements.phone.focus({ preventScroll: false }), 300);
})();
